module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }